import React, { useEffect, useState } from "react";

import { FiEdit } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import { getComplianceDataFromCalender } from "src/services/dashboardImplementor";
import { useTranslation } from "react-i18next";
import { MdOutlineReviews } from "react-icons/md";
import "./calender.css"
import Button from "src/components/Buttons/Button";
interface Action {
  id: string;
  compliance_id: string;
  domain_id: string;
  control_id: string;
  due_date: string;
  status: string;
  compliance_status: string;
  assign_to_manager: string;
  assign_to_implementer: string;
  manager: {
    id: string;
    name: string;
  };
  implementer: {
    id: string;
    name: string;
  };
  compliance: {
    code: string;
    complianceItem_en: string;
  } | null; // Allow compliance to be null
  domain: {
    en_name: string;
  } | null; // Allow domain to be null
  control: {
    name: string;
    description: string;
  };
  complianceControlActionsComments: {
    comment: string;
  }[];
}

export default function TaskUserCalender() {
  const navigate = useNavigate(); // React Router navigate hook
  const { t } = useTranslation();

  const [actions, setActions] = useState<Action[]>([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const selectedDate = queryParams.get("date");

  useEffect(() => {
    async function fetchData() {
      if (selectedDate) {
        try {
          const response = await getComplianceDataFromCalender(selectedDate, selectedDate);
          //console.log(response)
          if (response?.success) {
            const fetchedActions = response?.data?.actions;

            // Ensure fetchedActions is an array before setting state
            if (Array.isArray(fetchedActions)) {
              setActions(fetchedActions);
            } else {
              console.error("Expected an array for actions, received:", fetchedActions);
              setActions([]); // Fallback to an empty array
            }
          } else {
            console.error("API did not return success:", response);
            setActions([]); // Handle unsuccessful API response
          }
        } catch (error) {
          console.error("Error fetching compliance data:", error);
          setActions([]); // Handle error by resetting actions
        }
      }
    }

    fetchData();
  }, [selectedDate]);

  return (
    <div className="root">
  <div style={{ padding: "20px", backgroundColor: "#f9f9f9" }}>
    <h5 style={{ marginBottom: "20px", color: "#3296d4" }}>
      Compliance Actions for <span style={{ color: "#555" }}>{selectedDate}</span>
    </h5>
    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "20px" }}>
      {actions?.map((action, index) => (
        <div
          key={action.id}
          style={{
            border: "1px solid #ddd",
            borderRadius: "10px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            padding: "20px",
            backgroundColor: "#fff",
          }}
        >
          <h5 style={{ color: "#3296d4", marginBottom: "15px" }}>
            <b>Task {index + 1}</b>
          </h5>
          
          <table style={{ width: "100%", marginBottom: "15px", border: "1px solid #ddd", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#f2f2f2" }}>
                <th style={{ padding: "10px", border: "1px solid #ddd", textAlign: "left" }}>Field</th>
                <th style={{ padding: "10px", border: "1px solid #ddd", textAlign: "left" }}>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}><strong>Domain:</strong></td>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>{action.domain ? action.domain.en_name : "No Domain Data"}</td>
              </tr>
              <tr>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}><strong>Control:</strong></td>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>{action.control?.name || "No Control Name"}</td>
              </tr>
              <tr>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}><strong>Description:</strong></td>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>{action.control.description || "No Description Available"}</td>
              </tr>
              <tr>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}><strong>Due Date:</strong></td>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>{new Date(action.due_date).toLocaleDateString()}</td>
              </tr>
              <tr>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}><strong>Status:</strong></td>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>{action.status || "No Status Available"}</td>
              </tr>
              <tr>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}><strong>Compliance Status:</strong></td>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>{action.compliance_status || "No Compliance Status"}</td>
              </tr>
              <tr>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}><strong>Manager:</strong></td>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>{action.manager.name || "No Manager Data"}</td>
              </tr>
              <tr>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}><strong>Implementer:</strong></td>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>{action.implementer?.name || "No Implementer Data"}</td>
              </tr>
              <tr>
                <td style={{ padding: "10px", verticalAlign: "top", border: "1px solid #ddd" }}><strong>Comments:</strong></td>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                  {action?.complianceControlActionsComments?.length > 0 ? (
                    <ul style={{ paddingLeft: "20px", margin: 0 }}>
                      {action.complianceControlActionsComments.map((comment, index) => (
                        <li key={index} style={{ fontSize: "14px", marginBottom: "5px" }}>
                          {comment.comment}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p style={{ fontSize: "14px", color: "#6c757d", margin: 0 }}>No comments available</p>
                  )}
                </td>
              </tr>
            </tbody>
          </table>

          <button 
            className="btn_complete_model-warning rounded w-25"
            onClick={() => navigate(`/compliances/view-control/${action.control_id}/${action.compliance_id}/${action.domain_id}`)}
          >
            {t("Compliance_Status_Page.view_task") as string}
            <MdOutlineReviews className="mx-2" size={20}/>
          </button>
        </div>
      ))}
    </div>
  </div>
</div>
  );
}